// import React from "react";
import { GetStaticProps } from "next/types";
import nextI18nextConfig from "next-i18next.config";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { OlympiadJane } from "@cs/screens/olympiad";
import olympiadLayout from "../../layouts/Olympiad.layout";
import OlympiadHero from "@cs/screens/olympiad/hero/OlympiadHero";
import Partners from "@cs/screens/partners/Partners";
import BringToFriends from "@cs/screens/olympiad/bringToFriends/BringToFriends";
import Benefits from "@cs/screens/olympiad/benefits/Benefits";
import HowItWorks from "@cs/screens/olympiad/how-it-works/HowItWorks";
import Deadline from "@cs/screens/olympiad/deadline/Deadline";
import styles from "./index.module.scss";

const OlympiadPage = () => 
  (
    <main className={styles.main}>
      <OlympiadHero />
      <Benefits />
      <HowItWorks />
      <Deadline />
      <OlympiadJane />
      <Partners color="grey"/>
      <BringToFriends />
    </main>
  )

OlympiadPage.getLayout = olympiadLayout;

export default OlympiadPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(
      locale ?? "en",
      ["common", "footer", "nav", "olympiad", "_links", "landing-page", "seo"],
      nextI18nextConfig
    )),
    locale
  }
});